
// Vue Filtering
// gets all posts
export const peopleFeed = ({ items }) => {
  const allPosts = items;

  return {
    allPosts,
    chosenCategory: "",
    get filteredItems() {
      //no filters? show them all
      if (this.chosenCategory === "" || this.chosenCategory === "All") {
        return this.allPosts;
      }

      return this.allPosts.filter((l) => l.category == this.chosenCategory);
    },
  };
};
